import React from 'react';
import '../../../App.css';
import SideBar from 'components/layout/sidebar/Sidebar';
import DashboardNavBar from 'components/layout/DashboardNavBar';
import UsersForm from './UsersForm';

const CallViewUsers = ({ match }) => {
    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <UsersForm id={match.params.id} context={'view'} />
        </div>
    );
};
export default CallViewUsers;
